import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Log from "./log";
import Logs from "./logs";
import Loading from "./loading";
import TypesOfLocationEnum from "./typesOfLocationEnum";
import JSZip from "jszip";
import readmeContent from "./readmeContent";
import DownloadItems from "./downloadItems";
import formatTimeRead from "./formatTimeRead";

const LogViewer = ({ gradedQuestions, updateLogs, logs, name, updateCurrentViewer }) => {
    const { courseCode, assessmentCode, email } = useParams();
    const [requestLifeCycle, setRequestLifeCycle] = useState(false);

    const fetchLogs = async () => {
        try {
            setRequestLifeCycle(true);
            const response = await fetch(process.env.REACT_APP_SUBMISSION_API_URL + `/get-logs/${courseCode}/${assessmentCode}/${email}`, {
                method: "GET",
                credentials: "include"
            })
            const data = await response.json();

            if (response.status === 200) {
                updateLogs(data.logs);
            } else if (response.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            }

        } catch(error) {
            console.log(error);
        } finally {
            setRequestLifeCycle(false);
        }
    }

    useEffect(() => {
        if (logs === null) {
            fetchLogs();
        }
    }, [])

    const downloadLogs = async () => {
        const zip = new JSZip();

        // Add the log file
        const logContent = JSON.stringify(logs, null, 2);
        const formatted = formatTimeRead();
        const logFileName = `${name}-logs-${formatted}.json`;
        zip.file(logFileName, logContent);

        // Add the README file
        zip.file("README.md", readmeContent);

        // Generate ZIP
        const blob = await zip.generateAsync({ type: "blob" });

        // Create a download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = logFileName;
        a.click();

        // Cleanup
        URL.revokeObjectURL(url);
    };

    const backToSubmission = () => {
        updateCurrentViewer(TypesOfLocationEnum.SETTINGS)
    }

    return (
        <>
            {
                requestLifeCycle ?

                <div className="loading-zip-container">
                    <Loading />
                </div>

                :

                <>
                    <div className="log-viewer-container">
                        {
                            logs?.length > 0 ?

                            <>
                                <DownloadItems svg={<Logs />} label={"Download Logs"} handleClick={downloadLogs}/>
                                {
                                    logs && Array.isArray(logs) && (() => {
                                        const groupedLogs = new Map();

                                        logs.forEach((log) => {                                            
                                            const date = new Date(log.e);
                                            const localDate = date.toLocaleDateString('en-US');
                                            const dateKey = localDate;
                                            
                                            if (!groupedLogs.has(dateKey)) {
                                                groupedLogs.set(dateKey, []);
                                            }
                                            groupedLogs.get(dateKey).push(log);
                                        });

                                        return Array.from(groupedLogs.entries()).map(([dateKey, logsForDate]) => {                                            
                                            const dateParts = dateKey.split('/');
                                            const month = parseInt(dateParts[0]) - 1;
                                            const day = parseInt(dateParts[1]);
                                            const year = parseInt(dateParts[2]);                                                                                    
                                            const displayDate = new Date(year, month, day);
                                            
                                            const formattedDate = displayDate.toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric',
                                            });

                                            return (
                                                <div key={dateKey} className="log-viewer-container-small" style={{ padding: "0px" }}>
                                                    <div style={{ fontSize: "var(--font-size-two)", marginBottom: "-12px" }}>{formattedDate}:</div>
                                                    {logsForDate.map(log => (
                                                        <Log gradedQuestions={gradedQuestions} key={log.e} log={log} />
                                                    ))}
                                                </div>
                                            );
                                        });
                                    })()
                                }

                            </>

                            :

                            <>
                                <div className="no-assignments-container" style={{ height: "100vh" }}>
                                    <div className="no-assignments"> 
                                        This submission currently has no code logs
                                        <div className="save-changes-2" onClick={ backToSubmission } style={{ width: "200px" }}>
                                            Back To Submission
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </>
            }
        </>
    );
}

export default LogViewer;